@if (toastsSignal().length) {
  <div
    class="notification"
    [ngClass]="{ 'dismiss-animation': playDismissAnimation }"
  >
    <ng-container *ngTemplateOutlet="notificationTemplate"></ng-container>
  </div>
  @if (showStack) {
    <div class="stack notification">
      <ng-container *ngTemplateOutlet="notificationTemplate"></ng-container>
    </div>
  }
}

<ng-template #notificationTemplate>
  @if (toasts.length) {
    <img
      [src]="toasts[0].type === 'error' ? 'assets/logos/toast_error.svg' : 'assets/logos/toast_success.svg'"
      width="45px"
      height="45px"
      margin-right="10px"
      margin-top="5px"
      alt="notification"
    />
    <p>{{ toasts[0].message }}</p>
    <button
      class="notification__dismiss-button"
      (click)="dismiss()"
    >
      <img
        src="assets/logos/cross.svg"
        width="15px"
        height="15px"
        alt="dismiss"
      />
    </button>
  }
</ng-template>

<ng-template #defaultContent> Not supported notification type </ng-template>
